<template>
   <a-modal class="" title="单据模板-详情" :visible="detailVisible"
      @cancel="detailVisible=false" width="60%">
      <template slot="footer">
        <a-button key="back" @click="detailVisible=false">取消</a-button>
        <a-button key="back" type="primary" @click="preBack" v-if="stepCurrent>0">上一步</a-button>
        <a-button key="submit" type="primary" @click="submit" v-if="stepCurrent != 1 ">下一步</a-button>
      </template>
      <div class="containerTop">
        <a-steps v-model="stepCurrent" size="small">
          <a-step title="明细字段维护" disabled />
          <a-step title="基础信息维护" disabled />
          <a-step title="完成" disabled />
        </a-steps>
      </div>
      <div class="containerBottom" v-if="stepCurrent==0">
        <div class="view">
          <div class="ico">
            <a-icon class="circle" type="info-circle" />
          </div>
          <div class="hiteBox">
            <div class="hb">说明</div>
            <div class="hite">您可以基于【财务规则】来配置所需的费用明细。【支付金额】不必在此进行维护；</div>
          </div>
        </div>
        <div class="tableSelect">
          <a-table :data-source="modelInfo.data" ref="bodyTop" :pagination="false" bordered>
            <a-table-column key="id" data-index="id" title="选择控件" width="240px">
              <template slot-scope="text, record,index">
                <a-select v-model="record.id" style="width: 100%" placeholder="请选择" disabled
                  @change="changeFormItem($event,record,index)">
                  <a-select-option v-for="(item,idx) in configs" :key="idx" :value="item.id">{{item.label}}
                  </a-select-option>
                </a-select>
              </template>
            </a-table-column>
            <a-table-column key="context" data-index="context" title="选项">
              <template slot-scope="text, record">
                <a-input v-model="record.context" placeholder="请输入" disabled ></a-input>
              </template>
            </a-table-column>
            <a-table-column key="required" data-index="required" title="是否必填" width="150px">
              <template slot-scope="text, record">
                <a-switch default-checked v-model="record.required" disabled />
              </template>
            </a-table-column>
            <a-table-column key="required" data-index="required" title="插入至明细名称" width="150px" >
              <template slot-scope="text, record">
                <a-switch default-checked v-model="record.control_id" disabled />
              </template>
            </a-table-column>
          </a-table>
        </div>
      </div>
      <div class="containerBottom" v-if="stepCurrent==1">
       <a-form-model :model="modelInfo.BaseInformation" ref="modelInfo"  :rules="rules" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
          <!-- <div class="selfModel"> -->
            <a-row >
              <a-col :span="8">
                  <a-form-model-item label="费用类别名称" prop="name">
                    <a-input v-model="modelInfo.BaseInformation.name" placeholder="请输入费用类别名称" disabled/>
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                  <a-form-model-item label="归属类别" prop="type">
                    <a-input v-model="modelInfo.BaseInformation.type" disabled placeholder="请输入费用类别名称" />
                  </a-form-model-item>
              </a-col>
              <a-col :span="8">
                <a-form-model-item label="关联审批流" prop="processKey">
                    <a-select  allowClear  placeholder="请选择关联审批流类型"  v-model="modelInfo.BaseInformation.processKey"  disabled
                                style="width: 100%;" show-search :filter-option="filterOption">
                        <a-select-option :value="item.id" v-for="(item, index) in Approvallist" :key="index">
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                  <!-- <a-select v-model="modelInfo.BaseInformation.processKey" style="width: 100%" placeholder="请选择审批流">
                    <a-select-option value="1">关联 </a-select-option>
                    <a-select-option value="2">不关联 </a-select-option>
                  </a-select> -->
                </a-form-model-item>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="8">
                <a-form-model-item label="排序" prop="level">
                  <a-input v-model="modelInfo.BaseInformation.level"  placeholder="请输入" disabled />
                </a-form-model-item>
              </a-col>
            </a-row>
          <!-- </div> -->
        </a-form-model>
        <div class="boxlen">
          <div class="boxtitle">说明提示 
            <a-tooltip placement="topLeft"
              title="此说明，维护完成后会在【应用层同步显示】，您可以提示用户此流程需要注意的相关的规则信息等内容；">
              <a-icon type="info-circle" class="boxlencircle" />
            </a-tooltip>
          </div>
          <span style="font-weight: 700; padding: 5px 0 5px 10px; display: inline-block; color: black;">{{modelInfo.BaseInformation.mark}}</span>
         
        </div>
        <div class="boxlen">
          <div class="boxtitle">默认抄送人 </div>
          <span style="font-weight: 700; padding: 5px 0 5px 10px;  display: inline-block; color: black;" v-for="(item, index) in modelInfo.BaseInformation.ccs" :value="item.key" :key="index" >{{item.label}}</span>
          
          <!-- <a-select mode="multiple" label-in-value :value="value" v-model="modelInfo.BaseInformation.ccs"
            placeholder="请选择" style="width: 100%" :filter-option="false" disabled
            :not-found-content="fetching ? undefined : null" @search="fetchUser">
            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
            <a-select-option v-for="(item,index) in users" :key="index" :value="item.userId" >
              {{ item.userName }}
            </a-select-option>
          </a-select> -->
        </div>
        <div class="boxlen">
             <div  style="font-weight: 700; padding: 5px 0 5px 0;  display: inline-block; color: black;">参数配置 </div>
          <div class="sys">
            <div style="font-weight: 700; color: black;margin-bottom:5px;"><span style="color: #1990FF;">1、</span>项目相关参数</div>
            <div class="sysItem">
              <div class="sysTitle">是否需要维护【项目信息】?</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isCheckInformation" disabled/>
            </div>
            <div class="sysItem">
              <div class="sysTitle">是否需要收集项目金额进行判断？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isCheckProjectMoney" disabled/>
            </div>
             <div class="sysItem">
              <div class="sysTitle">是否需要查询项目信息？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isFindProject" disabled/>
            </div>
           
            <div style="font-weight: 700; color: black;margin-bottom:5px;">
              <span style="color: #1990FF;">2、</span>关联审批参数</div>
            <div class="sysItem">
              <div class="sysTitle">此【类别】是否需要关联其他【审批】信息？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isRelationAudit" disabled />
            </div>
            <div class="sysItem">
              <div class="sysTitle">此【类别】是否需要关联其他【采购物品】信息？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isRelationPurchase" disabled />
            </div>
            <div style="font-weight: 700; color: black;margin-bottom:5px;"><span style="color: #1990FF;">3、</span>报销参数配置</div>
             <div class="sysItem">
              <div class="sysTitle">此【类别】中【发票信息】是否【必填】？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isCheckBill" disabled />
            </div>
            <div class="sysItem">
              <div class="sysTitle">是否支持支付宝账户场景？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isAlipay" disabled />
            </div>
            <div class="sysItem">
              <div class="sysTitle">是否把控“自己申请自己”的款项？</div>
              <div class="sysline">
                <a-divider dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isControllerSelf" disabled/>
            </div>

          </div>
          <!-- <div class="boxtitle">参数配置 </div>
          <div class="sys">
            <div class="sysItem">
              <div class="sysTitle">是否需要维护【项目信息】?</div>
              <div class="sysline">
                <a-divider disabled dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isCheckInformation" />
            </div>
            <div class="sysItem">
              <div class="sysTitle">此【类别】中【发票信息】是否【必填】？</div>
              <div class="sysline">
                <a-divider disabled dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isCheckBill" />
            </div>
            <div class="sysItem">
              <div class="sysTitle">此【类别】是否需要关联其他【审批】信息？</div>
              <div class="sysline">
                <a-divider disabled dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isRelationAudit" />
            </div>
            <div class="sysItem">
              <div class="sysTitle">此【类别】是否需要关联其他【采购物品】信息？</div>
              <div class="sysline">
                <a-divider disabled dashed></a-divider>
              </div>
              <a-switch default-checked v-model="modelInfo.BaseInformation.isRelationPurchase" />
            </div>

          </div> -->
        </div>
      </div>
    </a-modal>
</template>

<script>
import { get_confiig, get_template, audit_list} from '@/api/financial'
export default {
  data() {
    return {
      detailVisible: false,
      Approvallist: [],
       configs: [],
       stepCurrent: 0,//步骤
       information: '',
       modelInfo: {
        id: undefined,
        data: [],
        BaseInformation: {
          name: "",
          processKey: undefined,
          type: "",
          mark: "",
          cc: "",
          ccs: [],
          isCheckInformation: false,
          isCheckBill: false,
          isRelationAudit: false,
          isRelationPurchase: false,
          directoryId: "634fafc0ca8ee0541b6fad08",
          live: 1,
        }
      },
    }
  },
   mounted() {
    this.getList()
  },
  methods: {
     getList() {
			 audit_list().then((res) => {
				if (res.code == 200) {
				this.Approvallist = res.data
				console.log(this.Approvallist, 'this.Approvallist')
				}
			})
		},
    init(row) {
      get_template({ id: row.id }).then(res => {
        if (res.code != 200) {
          return this.$message.error(res.msg);
        }
        get_confiig().then(cof => {
          if (cof.code != 200) {
            return this.$message.error(cof.msg);
          }
           if(res.data.detail[0][0].index_name === 'fee_dept') {
            res.data.detail[0].splice(0,1)

          }
          //  res.data.detail[0].splice(0,1)
           var length = res.data.detail[0].length
           res.data.detail[0].splice(length-2,2)
          this.modelInfo = {
            id: res.data.id,
            data: res.data.detail[0],
            BaseInformation: res.data.BaseInformation
          };
          this.configs = cof.data.config;
          this.information = cof.data.information;
          this.stepCurrent = 0;
          this.detailVisible = true

        })
      })
    },
     //上一步
    preBack() {
      this.stepCurrent -= 1;
    },
      submit() {
      this.stepCurrent += 1
    }

  }
  

}
</script>

<style lang="less" scoped>
.modelCate {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 15px 0;
  box-sizing: border-box;
  border: 1px solid #FFA39E;
  border-radius: 3px;
  background: #fbe6e5;
  margin-top: 20px;
}

.formCate .ant-form-item {
  margin-bottom: 0 !important;
}
.boxlen {
    width: 100%;
    margin-bottom: 15px;
   

    .boxtitle {
      width: 100%;
      margin-bottom: 10px;

      .boxlencircle {
        font-size: 16px;
        margin-left: 5px;
        cursor: pointer;
      }
    }
.sys {
      width: 100%;

      .sysItem {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 24px;
        margin-bottom: 5px;

        .sysTitle {
          white-space: nowrap;
        }

        .sysline {
          width: 100%;
          padding: 0 10px;
          box-sizing: border-box;

          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
}
      .view {
    width: 100%;
    border: 1px solid #409EFF;
    padding: 5px 50px 5px 0;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #d9ecff;
    border-radius: 4px;
    color: #409EFF;

    .ico {
      width: 45px;
      height: 40px;
      float: left;
      display: flex;
      justify-content: center;
      align-items: center;

      .circle {
        font-size: 22px;
        color: #409EFF;
      }
    }

    .hiteBox {
      width: calc(100% - 45px);
      float: left;

      .hb {
        font-size: 15px;
        font-weight: 600;
        margin-bottom: 3px;
      }

    }

  }
  .tableSelect{
     margin-top: 15px;

  }
  .containerTop {
    margin: 10px 0;
  width: 100%;
}

</style>